












































































































































































// import Vue from 'vue'
// import Component from 'vue-class-component'

import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
// import { Getter, Mutation } from 'vuex-class'


import DigitalCurrency1DigitalCurrencySymbol from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-1-digital-currency-symbol.vue'
import DigitalCurrency6AccountUserProfilePicture from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-6-account-user-profile-picture.vue'

// import Groups1AddToGroupButton from '../../../../html-components-type-1-basic/basic-type-5-groups/groups-1-add-to-group-button.vue'


import DigitalCurrency5AccountThumbnail from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-5-account-thumbnail.vue'


import { projectVariables } from '../../../../../../../../../../service-for-environment-variables/environment-variables-type-1-general-variables/general-variables-type-1-project-variables/project-variables-1-introduction'


// const namespace = 'digitalCurrency'


@Component({
  components: {
    DigitalCurrency5AccountThumbnail,
    DigitalCurrency1DigitalCurrencySymbol,
    DigitalCurrency6AccountUserProfilePicture
    // Groups1AddToGroupButton
  }
})
class ProductResourceHelperComponents2Header extends Vue {

  @Prop({ default: '' }) productResourceId?: string

  temporaryImageUrl: string = 'https://ecoin-static-file-host.web.app/service-for-game-introduction/game-introduction-type-1-web-browser-introduction/web-browser-introduction-type-1-customer-website/public/img/icons/android-chrome-512x512.png'

  digitalCurrencyName = projectVariables.digitalCurrencyName

}

export default ProductResourceHelperComponents2Header
